import {
  BOOKMARK,
  COMMENT,
  EVENT,
  EVENT_PARTICIPATION,
  FOLLOW,
  FOLLOWEE_EVENT,
  FOLLOWEE_POST,
  GROUP_ACCESS_CONFIRMATION,
  GROUP_POST,
  MESSAGE,
  POST,
  RECOMMENT,
  UNKNOWN
} from 'src/constants/notifications'
import { IIdentifiable } from 'src/interfaces/'
import { IResourceLink } from 'src/interfaces/resource_links'

type NotificationEventCode =
    | typeof BOOKMARK
    | typeof COMMENT
    | typeof RECOMMENT
    | typeof MESSAGE
    | typeof GROUP_POST
    | typeof EVENT_PARTICIPATION
    // | 'flag'                      // TODO: NYI by frontend
    // | 'group_access_confirmation' // TODO: NYI by frontend
    // | 'view_count'                // TODO: NYI by frontend
    // we use this event code to handle all unknown notifications
    | typeof UNKNOWN
    | typeof GROUP_ACCESS_CONFIRMATION
    | FollowEventCodes
  ;

interface INotification extends IIdentifiable {
  body?: string;
  contextTeaser?: string;
  createdAt: string;
  eventCode: NotificationEventCode;
  initiator?: INotificationInitiator;
  isRead: boolean;
  resourceLink?: IResourceLink;
}

interface INotificationInitiator {
  image: string;
  name?: string;
}

export const commentableTypes = {
  event: EVENT,
  post: POST
} as const

export interface IMessageNotification extends INotification {
  eventCode: typeof MESSAGE;
}

export interface IGroupAccessConfirmationNotification extends INotification {
  eventCode: typeof GROUP_ACCESS_CONFIRMATION;
}

type FollowEventCodes = typeof FOLLOW | typeof FOLLOWEE_POST | typeof FOLLOWEE_EVENT;

export interface IEventParticipationNotification extends INotification {
  eventCode: typeof EVENT_PARTICIPATION;
}

export interface IUnknownNotification extends INotification {
  eventCode: typeof UNKNOWN;
}
